import React from 'react';
import { get } from 'lodash';
import { notification } from 'antd';

const checkDuplicateErrorMessages = (desc, item) => {
  return desc.filter(element => get(element, 'props.children') === item);
};

const getErrorMessages = formSection => {
  if (formSection) {
    const desc = [];
    Object.keys(formSection).forEach(k => {
      const item = formSection[k];
      if (item instanceof Object) {
        return desc.push(getErrorMessages(item));
      } else {
        if (checkDuplicateErrorMessages(desc, item)[0]) return;
        desc.push(<p key={k}>{item}</p>);
      }
    });
    if (desc && desc.length > 0) {
      return desc;
    }
  }
};

export const notifyFormErrors = formErrors => {
  if (formErrors) {
    const desc = getErrorMessages(formErrors);

    if (desc && desc.length > 0) {
      notification.error({
        message: 'Form is invalid',
        description: desc,
      });
    }
  }
};

export const validateFieldSchema = validationSchema => (
  value,
  allValues,
  props,
  name,
) => {
  try {
    validationSchema.validateSyncAt(name, allValues);
    return;
  } catch (err) {
    return err.errors && err.errors[0];
  }
};
